"use client";

import { StoreType, TestTypeSectionContent } from "@/common/lib/types";
import { FC } from "react";
import StoreServiceTile from "./components/StoreServiceTile";
import { getTranslatedServiceName, SupportedLocale, getTranslatedDescription, getTranslatedBadge } from "@/api/mReserve/serviceTranslations";
import LoaderPanel from "@/common/components/LoaderPanel";

interface EyeTestTypeViewProps {
  storeDetails?: StoreType;
  content?: TestTypeSectionContent;
  handleClickEvent: (type: string) => void;
  services: Array<{ id: number; name: string; description: string; service_icon?: string | null; badge_text?: string | null }>;
  loading: boolean;
  locale: string;
}

const EyeTestTypeView: FC<EyeTestTypeViewProps> = ({ storeDetails, content, handleClickEvent, services, loading, locale }) => {
  if (loading) {
    return <LoaderPanel />;
  }

  // Ensure services is always an array
  const servicesArray = Array.isArray(services) ? services : [];

    // Extract language part (locale "sa-ar" → "ar")
  const lang = (locale.split("-")[1] || "en") as SupportedLocale;

  // Map mReserve services to test types format
    const mappedTestTypes = servicesArray.map((service) => ({
    key: service.id.toString(),
    title: getTranslatedServiceName(service.name, lang),
    description: getTranslatedDescription(service.name, lang) || service.description, // Fallback to original if no translation
    serviceId: service.id,
    serviceName: getTranslatedServiceName(service.name, lang),
    serviceIcon: service.service_icon, // Pass icon
    batchText: getTranslatedBadge(service.badge_text, lang), // "Free" → "مجاني"
  }));

  return (
    <div className="flex w-full flex-col gap-6">
      {storeDetails && (
        <div className="flex w-full flex-col items-start gap-4 border-b border-tertiary-3 pb-5">
          <span>
            <span className="text-[1rem] font-bold">Selected store: </span>
            <span className="text-sm font-normal">{storeDetails?.name}</span>
          </span>
        </div>
      )}
      {mappedTestTypes.map((testType) => (
        <StoreServiceTile
          type={testType.serviceName as any}
          {...testType}
          key={testType.key}
          storeDetails={storeDetails}
          warningMessage={content?.serviceNotAvailableWarning}
          handleClickEvent={handleClickEvent}
          locale={locale} // Pass locale to StoreServiceTile
        />
      ))}
    </div>
  );
};

export default EyeTestTypeView;
